export enum MicrosoftOAuthErrors {
  FETCH_STATUS_FAILED = 'Failed to load Microsoft connection status',
  GET_AUTH_URL_FAILED = 'Failed to generate Microsoft authorisation URL',
  REVOKE_FAILED = 'Failed to disconnect Microsoft account',
  REFRESH_FAILED = 'Failed to refresh Microsoft token',
  NOT_LINKED = 'No Microsoft account is currently linked',
  TOKEN_EXPIRED = 'Microsoft token has expired — please reconnect or force refresh',
}
